import { arrayOf, shape, string, integer } from 'prop-types';

export const pricingType = shape({
  url: string,
  currency: string,
  price: integer,
});

export const pricingsType = arrayOf(pricingType);
